import { AbstractControl, ValidationErrors } from '@angular/forms';
import { HtmlUtils } from '../utils/html-utils';

export function htmlMaxCharacterValidator(maxCharacters: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const visibleCharacters = HtmlUtils.countVisibleCharacters(control.value);
    return visibleCharacters > maxCharacters ? { maxCharacters: $localize`You've exceeded the character limit` } : null;
  };
}
